//--------------------------------------------------
//
//  Controller
//
//--------------------------------------------------

import Base from "@/js/_MyLibs/Util/Base.es6";
import gsap from "gsap";
export default class Controller extends Base {
  constructor() {
    super();

    this.wrapper = document.querySelector(".js-wrapper");
    this.item = document.querySelectorAll(".js-transition_item");
    this.commonitem = document.querySelectorAll(".js-transition_item_common");
    this.btnwrap = document.querySelector(".js-togglebtn");
    this.mapbtn = document.querySelector(".js-togglebtn_mapbtn");
    this.gridbtn = document.querySelector(".js-togglebtn_gridbtn");

    this.lead = document.querySelector(".lead");

    this.setup();
    this.setEvents();
  }

  setup() {
    this.getPos();
  }

  getPos() {
    this.mapBtnPos = {
      x: this.lead.getBoundingClientRect().left + this.lead.clientWidth + 50,
      y: this.lead.getBoundingClientRect().top + window.scrollY
    };

    const posGridX = window.innerWidth >= 768 ? 82 : 30;
    const posGridY = window.innerWidth >= 768 ? 34 : 17;

    this.gridBtnPos = {
      x: posGridX,
      y: posGridY
    };
  }

  show(to, from) {
    const op = to == "home" ? 1 : 0;
    const pointerEvents = to == "home" ? "auto" : "none";

    if (to == "map") this.wrapper.style.height = `${window.innerHeight}px`;

    $(this.commonitem).css("pointer-events", pointerEvents);

    const tl = gsap.timeline();

    tl
      // wrapper
      .to(this.item, 1.0, {
        opacity: 1,
        ease: "power2.inOut"
      })
      // wrapper
      .to(
        this.commonitem,
        1.0,
        {
          opacity: op,
          ease: "expo.out"
        },
        0
      );
  }

  hide(from, to, next) {
    const tl = gsap.timeline();

    const bgColor = to == "home" ? "#fff" : "#000";
    const x = to == "home" ? this.mapBtnPos.x : this.gridBtnPos.x;
    const y = to == "home" ? this.mapBtnPos.y : this.gridBtnPos.y;
    const DOM1 = from == "home" ? this.mapbtn : this.gridbtn;
    const DOM2 = to == "map" ? this.gridbtn : this.mapbtn;

    $(this.commonitem).css("pointer-events", "none");

    tl
      // wrapper
      .to(this.item, 1.0, {
        opacity: 0,
        ease: "expo.out"
      })
      // wrapper
      .to(
        this.commonitem,
        1.0,
        {
          opacity: 0,
          ease: "expo.out"
        },
        0
      )
      // app
      .to(
        this.wrapper,
        1.0,
        {
          backgroundColor: bgColor,
          ease: "power2.inOut"
        },
        0
      )
      // DOM
      .to(
        DOM1,
        1,
        {
          opacity: 0,
          ease: "power2.inOut"
        },
        0
      )
      // DOM
      .to(
        DOM2,
        1,
        {
          opacity: 1,
          ease: "power2.inOut"
        },
        0.3
      )
      // btn
      .to(
        this.btnwrap,
        1,
        {
          top: y,
          left: x,
          ease: "power2.inOut"
        },
        0
      )
      // 遷移
      .add(() => {
        next();
      }, 0.6);
  }

  setEvents() {}
}



//////////////////
// WEBPACK FOOTER
// ./src/js/Transition/Controller.es6
// module id = null
// module chunks = 